/**
 * Looks for missing functions/objects that are part of modern
 * browser standard.
 * @return {boolean}
 */
const browserOutOfDate = () => {
    if (window && !window.ResizeObserver) {
        return true;
    }

    return false;
};

const hasShownOutOfDate = 'hasShownOutOfDate';
const trueString = 'true';

/**
 * Shows an warning alert dialog once if browserOutOfDate return true
 */
export const checkAndShowBrowserOutOfDateAlert = () => {
    const hasShownAlert = localStorage.getItem(hasShownOutOfDate);

    if (hasShownAlert === trueString) {
        return;
    }

    if (browserOutOfDate()) {
        localStorage.setItem(hasShownOutOfDate, trueString);
        alert(
            'Your browser is out of date and may not support all ' +
                'features of this site. Please update your browser ' +
                'to the latest version for the best experience.'
        );
    }
};
